import { FieldValues, UseFormSetValue } from "react-hook-form";

import { ICatchARideAvailability, IFormAttributes } from "@ryde/shared";

export type TCatchARideAvailabilityListField = keyof Pick<
  ICatchARideAvailability,
  | "dayGroupIds"
  | "dayTypeIds"
  | "rideTypeIds"
  | "siteIds"
  | "unitIds"
  | "sectors"
  | "tags"
>;

export interface ICatchARideAvailabilityListCondition {
  name: TCatchARideAvailabilityListField;
  labelKey: string;
  isLabelCapitalized?: boolean;
  dropItemsSource: NonNullable<IFormAttributes["dropItemsSource"]>;
  /** Sectors are free-text values, so they are shown as-is instead of being resolved through a dropdown source. */
  isPlainTextValue?: boolean;
}

export interface ICatchARideAvailabilityItemForm {
  fieldName: string;
  index?: number;
  onEdit?: () => void;
  onCancelOuter?: () => void;
  onEditStart?: () => void;
  onEditEnd?: () => void;
  value?: Partial<ICatchARideAvailability>;
  setValueOuter?: UseFormSetValue<FieldValues>;
  removeHandler?: (index: number) => void;
  formAttributes?: IFormAttributes | null;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
}

/** Day conditions come first in the editor, like the other availability templates (day groups, day types, from, to). */
export const catchARideDayConditions: ICatchARideAvailabilityListCondition[] = [
  {
    name: "dayGroupIds",
    labelKey: "dayGroup.plural",
    isLabelCapitalized: true,
    dropItemsSource: "dayGroup",
  },
  {
    name: "dayTypeIds",
    labelKey: "dayType.plural",
    isLabelCapitalized: true,
    dropItemsSource: "dayType",
  },
];

/** Ride and passenger conditions, rendered after the time window. */
export const catchARideEntityConditions: ICatchARideAvailabilityListCondition[] =
  [
    {
      name: "rideTypeIds",
      labelKey: "rideType.plural",
      isLabelCapitalized: true,
      dropItemsSource: "rideType",
    },
    {
      name: "siteIds",
      labelKey: "site.plural",
      isLabelCapitalized: true,
      dropItemsSource: "site",
    },
    {
      name: "unitIds",
      labelKey: "unit.plural",
      isLabelCapitalized: true,
      dropItemsSource: "unit",
    },
    {
      name: "sectors",
      labelKey: "produceButton.formLabel.sectors",
      dropItemsSource: "passengerSector",
      isPlainTextValue: true,
    },
    {
      name: "tags",
      labelKey: "produceButton.formLabel.tags",
      dropItemsSource: "systemTag",
    },
  ];

/** Every list condition, in display order. */
export const catchARideAvailabilityListConditions: ICatchARideAvailabilityListCondition[] =
  [...catchARideDayConditions, ...catchARideEntityConditions];

export const emptyCatchARideAvailability: ICatchARideAvailability = {
  from: undefined,
  to: undefined,
  dayGroupIds: [],
  dayTypeIds: [],
  rideTypeIds: [],
  siteIds: [],
  unitIds: [],
  sectors: [],
  tags: [],
};
